import { render, staticRenderFns } from "./TpIframe.vue?vue&type=template&id=a00a3324&scoped=true&"
import script from "./TpIframe.vue?vue&type=script&lang=js&"
export * from "./TpIframe.vue?vue&type=script&lang=js&"
import style0 from "./TpIframe.vue?vue&type=style&index=0&id=a00a3324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a3324",
  null
  
)

component.options.__file = "TpIframe.vue"
export default component.exports